<template>
    <div>
        <tile-question-layout :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :fabricator="fabricator">

        </tile-question-layout>
    </div>
</template>

<script type="text/ecmascript-6">
    import TileQuestion from "../mixin/TileQuestion.vue";
    import DesignerQuestionSelectSideGlass from "../DesignerQuestionSelectSideGlass.vue";

    export default {
        mixins: [
            DesignerQuestionSelectSideGlass,
            TileQuestion
        ],
        props:{
            title: {
                default(){
                    return 'Select Side Panel Glass';
                }
            },
            frameCombination: {
                required: true
            },
            sideVariant: {
                required: true
            },
            securedByDesign: {
                required: true,
            },
            slab: {
                required: true,
            },
            typeRange: {
                required: true,
            },
        },
        computed: {
            thumbURL(){
                return '/thumb/glassloose/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/side-glass?frame_combination=' + this.frameCombination + '&secured_by_design=' + this.securedByDesign + '&side_variant=' + this.sideVariant + '&slab=' + this.slab + '&type_range=' + this.typeRange;
            },
            cache_key(){
                return '_' + this.frameCombination + '_' + this.securedByDesign + '_' + this.sideVariant + '_' + this.slab + '_' + this.typeRange;
            },
            passed_filter(){
                return this.variable_ready(this.frameCombination, this.securedByDesign, this.sideVariant, this.slab, this.typeRange);
            },
        },
        watch: {
            'frameCombination': function (val, oldVal) {
                this.update_options();
            },
            'securedByDesign': function (val, oldVal) {
                this.update_options();
            },
            'sideVariant': function (val, oldVal) {
                this.update_options();
            },
            'slab': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
